import { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

const btn = "h-9 inline-flex items-center px-3.5 rounded-lg text-sm font-semibold border border-slate-300 bg-white navy-text hover:bg-slate-50 transition-colors disabled:opacity-50";
const CHOICES = [["certidao", "A certidão está certa"], ["caderneta", "A caderneta está certa"], ["ambas", "Pedir as duas de novo"]];

// Duas áreas lado a lado (certificado vs caderneta) para decidir de relance.
export function AreaCompare({ items }) {
  return (
    <div className="mt-3 grid grid-cols-2 gap-2" data-testid="area-compare">
      {items.map((it, i) => (
        <div key={it.label} className="rounded-lg border border-slate-200 bg-slate-50/60 px-3 py-2.5" data-testid={`area-compare-${i}`}>
          <div className="text-xs text-slate-500">{it.source && it.source !== it.label ? `${it.source} · ` : ""}{it.label}</div>
          <div className={`${String(it.value).length > 14 ? "text-[15px]" : "text-xl"} font-semibold tabular-nums break-words ${it.wrong ? "text-[#B91C1C]" : "navy-text"}`} data-testid={`area-compare-value-${i}`}>{it.value}</div>
        </div>
      ))}
    </div>
  );
}

// Certidão ↔ caderneta: um só aviso com as duas lado a lado e a decisão do consultor.
export function PairConflict({ pid, table, ro, onChange }) {
  const [busy, setBusy] = useState(null);
  const pick = async (choice) => {
    setBusy(choice);
    try {
      await api.post(`/processes/${pid}/property-conflict`, { choice });
      toast.success(choice === "ambas" ? "Certidão e caderneta voltam a ser pedidas" : "Decisão registada");
      onChange();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
    setBusy(null);
  };
  return (
    <div className="mt-3" data-testid="pair-conflict">
      <div className="overflow-x-auto">
        <table className="w-full text-sm border border-slate-200 rounded-lg" data-testid="pair-table">
          <thead className="bg-slate-50 text-slate-500"><tr><th className="text-left font-medium px-3 py-2" /><th className="text-left font-medium px-3 py-2">Certidão permanente</th><th className="text-left font-medium px-3 py-2">Caderneta predial</th></tr></thead>
          <tbody>
            {(table || []).map((r) => (
              <tr key={r.label} className="border-t border-slate-100" data-testid={`pair-row-${r.label}`}>
                <td className="px-3 py-2 text-slate-500 whitespace-nowrap">{r.label}</td>
                <td className={`px-3 py-2 ${r.certidao !== r.caderneta ? "font-semibold navy-text" : "text-slate-700"}`}>{r.certidao}</td>
                <td className={`px-3 py-2 ${r.certidao !== r.caderneta ? "font-semibold navy-text" : "text-slate-700"}`}>{r.caderneta}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!ro && (
        <div className="flex flex-wrap gap-2 mt-3">
          {CHOICES.map(([k, l]) => <button key={k} onClick={() => pick(k)} disabled={!!busy} className={btn} data-testid={`pair-choice-${k}`}>{l}</button>)}
        </div>
      )}
    </div>
  );
}
